import { isImageFile } from '~/shared/file/files'
import { buildImageUrl } from '~/shared/common/image-url'

/**
 * Gets the appropriate URL for a file based on its type.
 * Images go through the resize worker, other files get direct S3 URLs.
 *
 * This is the ONLY place that derives file URLs from the `upload` field.
 * Never use the `url` column. Never hardcode S3 URLs.
 */
export function getFileUrl(
  s3Key: string,
  filename?: string | null,
  imageOptions?: {
    w?: number
    h?: number
    output_format?: 'webp' | 'jpeg' | 'png' | 'avif'
    fit?: 'cover' | 'contain' | 'scale-down' | 'pad'
    quality?: number
  }
): string {
  if (!filename || !isImageFile(filename)) {
    return `https://revelstreet-media-production.s3.amazonaws.com/${s3Key.startsWith('media/') ? s3Key : 'media/' + s3Key}`
  }

  return buildImageUrl(s3Key, imageOptions)
}
